import { gql } from '@apollo/client';

const Fragments = {
  property: gql`
    fragment property on Property {
      id
      propertyCode
      propertyName
      propertyTypeId
      propertyTypeCode
      propertyTypeName
      orderNo
      readOnly
      allowAllContext
      allowDefaultRead
      allowDefaultWrite
      categoryId
      categoryName
      decimalPlaces
    }
  `,

  propertyContext: gql`
    fragment propertyContext on PropertyContext {
      propertyId
      contextId
    }
  `,

  propertyUserGroup: gql`
    fragment propertyUserGroup on PropertyUserGroup {
      propertyId
      userGroupId
      allowRead
      allowWrite
    }
  `,

  propertyApplication: gql`
    fragment propertyApplication on PropertyApplication {
      id
      propertyId
      appCode
    }
  `
};

export default Fragments;
